import * as z from "zod";

export const getCoverageCreditIncentiveRevenue = {
  name: "getCoverageCreditIncentiveRevenue" as const,
  input: z.object({
    startDate: z
      .string()
      .describe("Start date for the analytics period (YYYY-MM-DD)"),
    endDate: z
      .string()
      .describe("End date for the analytics period (YYYY-MM-DD)"),
  }),
  output: z.object({
    enabled: z
      .boolean()
      .describe("Whether the team has the coverage credit incentive on"),
    revenue: z
      .number()
      .describe(
        "Upsell revenue from the coverage credit granted and expiring automations",
      ),
  }),
};
